// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useRef, useLayoutEffect, useState, ComponentPropsWithRef } from 'react';
import { CardTypes } from '../../types/Model';
import Domain from '../common/Domain';
import Platform from '../common/Platform';
import { ProductCard } from './types';
import { parseDuration } from '../../lib/utility';
import { S } from './styles';
import moment from 'moment';
import { InfoTextType } from './components/InfoText';
import { FormattedMessage, useIntl } from 'react-intl';

const DAYS_IN_MILLISECOND = 24 * 60 * 60 * 1000;

type CardProps = Omit<ComponentPropsWithRef<'a'>, 'id'> & ProductCard;

const Card:React.FC<CardProps> = (props):JSX.Element => {
  const {
    type,
    id,
    name,
    platformId,
    domainIds,
    totalDuration,
    levelId,
    language,
    imageUrl
  } = props;

  const [showScrollMore, setShowScrollMore] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const intl = useIntl(); // remove this line will cause workshop left time won't change while changing langauge.

  // show if overflow
  useLayoutEffect(() => {
    if (ref.current && ref.current.offsetHeight < ref.current.scrollHeight) {
      setShowScrollMore(true);
    } else {
      setShowScrollMore(false);
    }
  }, [ref])

  // not show if overflow and scrolled to bottom
  const handleScroll = (event:React.UIEvent<HTMLDivElement, UIEvent>) => {
    const target = event.target as HTMLDivElement;
    if ((target.scrollHeight - target.scrollTop) === target.clientHeight) {
      setShowScrollMore(false);
    } else {
      setShowScrollMore(true);
    }
  }

  const renderMinimalContent = () => {
    switch (props.type) {
      case CardTypes.WORKSHOP:
        return (
          <S.InfoContainer>
            <S.InfoText type={InfoTextType.DURATION}>{parseDuration(totalDuration).auto}</S.InfoText>
            { props.vodCount != 0 && (<S.InfoText type={InfoTextType.VOD}>{props.vodCount}</S.InfoText>) }
            { props.labCount != 0 && (<S.InfoText type={InfoTextType.LAB}>{props.labCount}</S.InfoText>) }
            { props.challengeCount != 0 && (<S.InfoText type={InfoTextType.CHALLENGE}>{props.challengeCount}</S.InfoText>) }
            { props.assessmentCount != 0 && (<S.InfoText type={InfoTextType.ASSESSMENT}>{props.assessmentCount}</S.InfoText>) }
            { props.examCount != 0 && (<S.InfoText type={InfoTextType.EXAM}>{props.examCount}</S.InfoText>) }
          </S.InfoContainer>
        )
      case CardTypes.COURSE:
        return (
          <S.InfoContainer>
            <S.InfoText type={InfoTextType.DURATION}>{parseDuration(totalDuration).auto}</S.InfoText>
            { props.vodCount != 0 && (<S.InfoText type={InfoTextType.VOD}>{props.vodCount}</S.InfoText>) }
            { props.labCount != 0 && (<S.InfoText type={InfoTextType.LAB}>{props.labCount}</S.InfoText>) }
            { props.challengeCount != 0 && (<S.InfoText type={InfoTextType.CHALLENGE}>{props.challengeCount}</S.InfoText>) }
            { props.assessmentCount != 0 && (<S.InfoText type={InfoTextType.ASSESSMENT}>{props.assessmentCount}</S.InfoText>) }
            { props.examCount != 0 && (<S.InfoText type={InfoTextType.EXAM}>{props.examCount}</S.InfoText>) }
          </S.InfoContainer>
        )
      case CardTypes.ILTCOURSE:
        return (
          <S.InfoContainer>
            <S.InfoText type={InfoTextType.DURATION}>{parseDuration(totalDuration).auto}</S.InfoText>
            { props.vodCount != 0 && (<S.InfoText type={InfoTextType.VOD}>{props.vodCount}</S.InfoText>) }
            { props.labCount != 0 && (<S.InfoText type={InfoTextType.LAB}>{props.labCount}</S.InfoText>) }
            { props.challengeCount != 0 && (<S.InfoText type={InfoTextType.CHALLENGE}>{props.challengeCount}</S.InfoText>) }
            { props.assessmentCount != 0 && (<S.InfoText type={InfoTextType.ASSESSMENT}>{props.assessmentCount}</S.InfoText>) }
            { props.examCount != 0 && (<S.InfoText type={InfoTextType.EXAM}>{props.examCount}</S.InfoText>) }
          </S.InfoContainer>
        )
      case CardTypes.LAB:
      case CardTypes.CHALLENGE:
      case CardTypes.EXAM:
      default:
        return (
          <S.InfoContainer>
            <S.InfoText type={InfoTextType.DURATION}>{parseDuration(totalDuration).auto}</S.InfoText>
          </S.InfoContainer>
        )
    }
  }

  const renderFullContent = () => {
    switch (props.type) {
      case CardTypes.WORKSHOP:
        return (
          <S.FullInfoContainer>
            <S.InfoText type={InfoTextType.DURATION}><FormattedMessage id="B008" values={{totalDuration: parseDuration(totalDuration).auto}}/></S.InfoText>
            { props.vodCount != 0 && (<S.InfoText type={InfoTextType.VOD}><FormattedMessage id="B010" values={{vodCount: props.vodCount}}/></S.InfoText>) }
            { props.labCount != 0 && (<S.InfoText type={InfoTextType.LAB}><FormattedMessage id="B011" values={{labCount: props.labCount}}/></S.InfoText>) }
            { props.challengeCount != 0 && (<S.InfoText type={InfoTextType.CHALLENGE}><FormattedMessage id="B037" values={{challengeCount: props.challengeCount}}/></S.InfoText>) }
            { props.assessmentCount != 0 && (<S.InfoText type={InfoTextType.ASSESSMENT}><FormattedMessage id="B012" values={{assignCount: props.assessmentCount}}/></S.InfoText>) }
            { props.examCount != 0 && (<S.InfoText type={InfoTextType.EXAM}><FormattedMessage id="B044" values={{examCount: props.examCount}}/></S.InfoText>) }
            <S.InfoText type={InfoTextType.LEVEL}><FormattedMessage id="B013"/><S.LevelMeter levelId={levelId} showName={true} /></S.InfoText>
            <S.InfoText type={InfoTextType.LANGUAGE}><FormattedMessage id="B014" values={{lang: language}}/></S.InfoText>
            <S.FooterWorkshopDatesText><FormattedMessage id="B015" values={{timeString: moment(props.startTime).format('YYYY/MM/DD HH:mm')}}/></S.FooterWorkshopDatesText>
            <S.FooterWorkshopDatesText><FormattedMessage id="B016" values={{timeString: moment(props.endTime).format('YYYY/MM/DD HH:mm')}}/></S.FooterWorkshopDatesText>
          </S.FullInfoContainer>
        )
      case CardTypes.COURSE:
        return (
          <S.FullInfoContainer>
            <S.InfoText type={InfoTextType.DURATION}><FormattedMessage id="B008" values={{totalDuration: parseDuration(totalDuration).auto}}/></S.InfoText>
            { props.vodCount != 0 && (<S.InfoText type={InfoTextType.VOD}><FormattedMessage id="B010" values={{vodCount: props.vodCount}}/></S.InfoText>) }
            { props.labCount != 0 && (<S.InfoText type={InfoTextType.LAB}><FormattedMessage id="B011" values={{labCount: props.labCount}}/></S.InfoText>) }
            { props.challengeCount != 0 && (<S.InfoText type={InfoTextType.CHALLENGE}><FormattedMessage id="B037" values={{challengeCount: props.challengeCount}}/></S.InfoText>) }
            { props.assessmentCount != 0 && (<S.InfoText type={InfoTextType.ASSESSMENT}><FormattedMessage id="B012" values={{assignCount: props.assessmentCount}}/></S.InfoText>) }
            { props.examCount != 0 && (<S.InfoText type={InfoTextType.EXAM}><FormattedMessage id="B044" values={{examCount: props.examCount}}/></S.InfoText>) }
            <S.InfoText type={InfoTextType.LEVEL}><FormattedMessage id="B013"/><S.LevelMeter levelId={levelId} showName={true} /></S.InfoText>
            <S.InfoText type={InfoTextType.LANGUAGE}><FormattedMessage id="B014" values={{lang: language}}/></S.InfoText>
          </S.FullInfoContainer>
        )
      case CardTypes.ILTCOURSE:
        return (
          <S.FullInfoContainer>
            <S.InfoText type={InfoTextType.DURATION}><FormattedMessage id="B008" values={{totalDuration: parseDuration(totalDuration).auto}}/></S.InfoText>
            { props.vodCount != 0 && (<S.InfoText type={InfoTextType.VOD}><FormattedMessage id="B010" values={{vodCount: props.vodCount}}/></S.InfoText>) }
            { props.labCount != 0 && (<S.InfoText type={InfoTextType.LAB}><FormattedMessage id="B011" values={{labCount: props.labCount}}/></S.InfoText>) }
            { props.challengeCount != 0 && (<S.InfoText type={InfoTextType.CHALLENGE}><FormattedMessage id="B037" values={{challengeCount: props.challengeCount}}/></S.InfoText>) }
            { props.assessmentCount != 0 && (<S.InfoText type={InfoTextType.ASSESSMENT}><FormattedMessage id="B012" values={{assignCount: props.assessmentCount}}/></S.InfoText>) }
            { props.examCount != 0 && (<S.InfoText type={InfoTextType.EXAM}><FormattedMessage id="B044" values={{examCount: props.examCount}}/></S.InfoText>) }
            <S.InfoText type={InfoTextType.LANGUAGE}><FormattedMessage id="B014" values={{lang: language}}/></S.InfoText>
            <S.InfoText type={InfoTextType.LOCATION}><FormattedMessage id="B064" values={{location: props.location}}/></S.InfoText>
            <S.FooterWorkshopDatesText><FormattedMessage id="B015" values={{timeString: moment(props.startTime).format('YYYY/MM/DD HH:mm')}}/></S.FooterWorkshopDatesText>
            <S.FooterWorkshopDatesText><FormattedMessage id="B016" values={{timeString: moment(props.endTime).format('YYYY/MM/DD HH:mm')}}/></S.FooterWorkshopDatesText>
          </S.FullInfoContainer>
        )
      case CardTypes.EXAM:
        return (
          <S.FullInfoContainer>
            <S.InfoText type={InfoTextType.DURATION}><FormattedMessage id="B041"/>{parseDuration(totalDuration).auto}</S.InfoText>
            <S.InfoText type={InfoTextType.LEVEL}><FormattedMessage id="B013"/><S.LevelMeter levelId={levelId} showName={true} /></S.InfoText>
            <S.InfoText type={InfoTextType.LANGUAGE}><FormattedMessage id="B014" values={{lang: language}}/></S.InfoText>
            <S.InfoText type={InfoTextType.EXAMMULTISELECT}><FormattedMessage id="B042" values={{examMultiSelect: props.multiSelect.expectedNumberOfQuestion}}/></S.InfoText>
            <S.InfoText type={InfoTextType.EXAMQA}><FormattedMessage id="B043" values={{examQna: props.qna.expectedNumberOfQuestion}}/></S.InfoText>
          </S.FullInfoContainer>
        )
      case CardTypes.LAB:
      case CardTypes.CHALLENGE:
      default:
        return (
          <S.FullInfoContainer>
            <S.InfoText type={InfoTextType.DURATION}><FormattedMessage id="B009"/>{parseDuration(totalDuration).auto}</S.InfoText>
            <S.InfoText type={InfoTextType.LEVEL}><FormattedMessage id="B013"/><S.LevelMeter levelId={levelId} showName={true} /></S.InfoText>
            <S.InfoText type={InfoTextType.LANGUAGE}><FormattedMessage id="B014" values={{lang: language}}/></S.InfoText>
          </S.FullInfoContainer>
        )
    }
  }

  const renderFooter = () => {
    switch (props.type) {
      case CardTypes.WORKSHOP:
        if ((props.startTime.getTime() - new Date().getTime()) > 0) {
          return (
            <S.FooterWorkshopDatesContainer>
              <S.FooterWorkshopDatesText><FormattedMessage id="B015" values={{timeString: moment(props.startTime).format('YYYY/MM/DD HH:mm')}}/></S.FooterWorkshopDatesText>
              <S.FooterWorkshopDatesText><FormattedMessage id="B016" values={{timeString: moment(props.endTime).format('YYYY/MM/DD HH:mm')}}/></S.FooterWorkshopDatesText>
            </S.FooterWorkshopDatesContainer>
          )
        } else {
          const totalDuration = props.endTime.getTime() - props.startTime.getTime();
          const leftTime = props.endTime.getTime() - new Date().getTime();
          const expireDuration = Math.min(Math.ceil(totalDuration / 3), 3 * DAYS_IN_MILLISECOND);

          return (
            <S.Footer>
              <S.FooterText
                isWorkshopExpiring={leftTime < expireDuration}><FormattedMessage id="B007" values={{timeString: moment(props.endTime).fromNow()}}/>
              </S.FooterText>
            </S.Footer>
          )
        }
      case CardTypes.ILTCOURSE:
        return (
          <S.Footer>
            <S.FooterText setLeft={true}>{language}</S.FooterText>
          </S.Footer>
        )
      case CardTypes.COURSE:
      case CardTypes.LAB:
      case CardTypes.CHALLENGE:
      case CardTypes.EXAM:
      default:
        return (
          <S.Footer>
            <S.LevelMeter levelId={levelId}/>
            <S.FooterText>{language}</S.FooterText>
          </S.Footer>
        )
    }
  }

  enum typeTag {
    onlineCourse = 'B005',
    iltCourse = 'B063',
    lab = 'B006',
    workshop = 'B004',
    challenge = 'B036',
    exam = 'B040'
  }

  return (
    <S.Container
      to={`/${type}s/${id}`}
      data-testid="card"
    >
      <S.TypeTagShadow />
      <S.Wrapper>
        <S.MinimalInfo>
          <S.ThumbnailWrapper>
            { props.isOwner ? (
              <S.OwnerContainer>
                <S.OwnerTag>Owner</S.OwnerTag>
              </S.OwnerContainer>
            ) : null}
            <S.Thumbnail src={imageUrl} alt="card-thumbnail" />

            <S.TagsContainer>
              { props.type !== CardTypes.ILTCOURSE ? (
                <>
                  <S.Tag><Platform id={platformId}/></S.Tag>
                  {
                    domainIds.map((id:number, index) => {
                      if (index < 1) {
                        return (<S.Tag key={index}><Domain id={id} /></S.Tag>)
                      } else if (index < 2) {
                        return (<S.Tag key={index}>+{domainIds.length - 1}</S.Tag>)
                      } else {
                        return null
                      }
                    })
                  }
                </>
              ) : null }
            </S.TagsContainer>
          </S.ThumbnailWrapper>
          <S.TypeTag>
            {props.type !== CardTypes.LAB && props.type !== CardTypes.CHALLENGE && props.type !== CardTypes.EXAM && props.completionProgress == 1 && <S.FinishedBadge />}
            <FormattedMessage id={typeTag[type]}/>
          </S.TypeTag>
          <S.Content>
            <S.Title>{name}</S.Title>
            {renderMinimalContent()}
            {renderFooter()}
          </S.Content>
          {
            props.type !== CardTypes.LAB && props.type !== CardTypes.CHALLENGE && props.type !== CardTypes.EXAM && <S.ProgressBar completionProgress={props.completionProgress}/>
          }
        </S.MinimalInfo>
        <S.FullInfo ref={ref} onScroll={handleScroll}>
          <S.FullInfoContent>
            <S.Title isFull={true}>{name}</S.Title>
            <S.DomainContainer>
              { props.isOwner ? (
                <S.OwnerFullContainer>
                  <S.OwnerTag>Owner</S.OwnerTag>
                </S.OwnerFullContainer>
              ) : null}
              <S.FullTagContainer>
                { props.type !== CardTypes.ILTCOURSE ? (
                  <>
                    <S.TagSecondary><Platform id={platformId}/></S.TagSecondary>
                    {
                      domainIds.map((domainId, index) =>
                        <S.TagSecondary key={index}><Domain id={domainId} /></S.TagSecondary>
                      )
                    }
                  </>) : null }
              </S.FullTagContainer>
            </S.DomainContainer>
            {renderFullContent()}
          </S.FullInfoContent>
        </S.FullInfo>
        {
          showScrollMore && (
            <S.ScrollDownFooter>
              <S.ScrollDownMask />
              <S.ScrollDownIcon />
            </S.ScrollDownFooter>
          )
        }
      </S.Wrapper>
    </S.Container>
  );
}

export default Card;
